// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1sgvV","selected":"Chip_selected__dFY2D"};